/**
 *
 * @module removeFromWatchlistQuery
 *
 */

import Check from 'check-types';
import Exception from './../../services/exception/entry';
import ContentQuery from './../contentQuery';
import GraphQlPersistedQuery from './../graphQlPersistedQuery';

const InvalidArgumentException = Exception.InvalidArgumentException;

/**
 *
 * @class RemoveFromWatchlistQuery
 * @extends {SDK.Content.ContentQuery}
 *
 */
export default class RemoveFromWatchlistQuery extends ContentQuery {

    /**
     *
     * @param {Array<String>} contentIds
     *
     */
    constructor(contentIds) {

        const errorMessage = {
            ctor: 'RemoveFromWatchlistQuery(contentIds)',
            get contentIds() {
                return `${this.ctor} needs Array of Strings`;
            }
        };

        Check.assert(
            Check.all(
                [
                    Check.array.of.nonEmptyString(contentIds),
                    Check.nonEmptyArray(contentIds)
                ]
            ),
            errorMessage.contentIds,
            InvalidArgumentException
        );

        const graphQlPersistedQuery = new GraphQlPersistedQuery('deleteFromWatchlist', {
            contentIds
        });

        super('watchlistPersisted', graphQlPersistedQuery);

    }

}



// WEBPACK FOOTER //
// ./src/content/watchlist/removeFromWatchlistQuery.js